import { render, staticRenderFns } from "./Techservice.vue?vue&type=template&id=a40bc032&scoped=true&"
import script from "./Techservice.vue?vue&type=script&lang=js&"
export * from "./Techservice.vue?vue&type=script&lang=js&"
import style0 from "./Techservice.vue?vue&type=style&index=0&id=a40bc032&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a40bc032",
  null
  
)

export default component.exports